module.exports = __webpack_public_path__ + "img/avatar6.67c2daec.png";